/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module MessageItemsModule
 */

import { L10nService } from '@vmw/ngx-vip';
import {
    Component,
    Type,
} from '@angular/core';

import { MessageItem } from 'ajs/modules/data-model/factories';
import { IAlertSyslogServer } from 'generated-types';
import { withFullModalMixin } from 'ajs/js/utilities/mixins';
import { AlertSyslogServer } from 'object-types';
import { TWindowElement } from 'ajs/modules/data-model/data-model.types';
import * as l10n from './alert-syslog-server.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Syslog Server Config Item.
 *
 * @author Guru Prasad, alextsg
 */
export class AlertSyslogServerConfigItem extends
    withFullModalMixin(MessageItem)<IAlertSyslogServer> {
    public static ngDependencies = [L10nService];

    /**
     * l10nService instance to register source bundles and get keys from source bundles.
     */
    private readonly l10nService: L10nService;

    constructor(args = {}) {
        const extendedArgs = {
            objectType: AlertSyslogServer,
            windowElement: 'lazy-load',
            ...args,
        };

        super(extendedArgs);

        this.l10nService = this.getNgDependency(L10nService);
        this.l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public getModalBreadcrumbTitle(): string {
        return this.l10nService.getMessage(l10nKeys.alertSyslogServerBreadcrumbTitle);
    }

    /**
     * Method used to import lazy-loaded modal component.
     */
    public async getModalComponent(windowElement: TWindowElement): Promise<Type<Component>> {
        const {
            AlertSyslogServerModalComponent,
        } = await import(
            /* webpackChunkName: "alert-syslog-config-modal" */
            // eslint-disable-next-line max-len
            'ng/lazy-loaded-components/modals/alert-syslog-config-modal/alert-syslog-server-modal/alert-syslog-server-modal.component'
        );

        return AlertSyslogServerModalComponent as Type<Component>;
    }
}
